export const SCHEMA_VERSION = Object.freeze({
  workspace: 1,
  canvas: 1,
  backup: 1,
  gallery: 1,
  groups: 1,
})

export function emptyCanvas() {
  return { nodes: [], edges: [], groups: [] }
}

export function normalizeCanvas(value) {
  const source = value && typeof value === 'object' ? value : {}
  return {
    nodes: Array.isArray(source.nodes) ? source.nodes : [],
    edges: Array.isArray(source.edges) ? source.edges : [],
    groups: Array.isArray(source.groups) ? source.groups : [],
  }
}

export function normalizeWorkspace(value) {
  const source = value && typeof value === 'object' ? value : {}
  const rawWorkspaces = Array.isArray(source.workspaces) ? source.workspaces : []
  const workspaces = rawWorkspaces.filter(Boolean).map((workspace, index) => {
    const canvas = normalizeCanvas(workspace)
    return {
      ...workspace,
      id: String(workspace.id || `ws_${index + 1}`),
      name: String(workspace.name || `工作台 ${index + 1}`),
      ...canvas,
      schemaVersion: SCHEMA_VERSION.canvas,
    }
  })
  if (!workspaces.length) {
    workspaces.push({ id: 'ws_default', name: '工作台 1', ...emptyCanvas(), schemaVersion: SCHEMA_VERSION.canvas })
  }
  const activeId = workspaces.some((workspace) => workspace.id === source.activeId)
    ? source.activeId
    : workspaces[0].id
  return {
    schemaVersion: SCHEMA_VERSION.workspace,
    workspaces,
    activeId,
    rev: Number.isFinite(Number(source.rev)) && Number(source.rev) > 0 ? Number(source.rev) : 1,
  }
}

export function normalizeTask(task = {}) {
  return {
    id: String(task.id || ''),
    sourceNodeId: String(task.sourceNodeId || ''),
    edgeId: task.edgeId == null ? null : String(task.edgeId),
    title: String(task.title || ''),
    text: task.text == null ? '' : String(task.text),
    refs: Array.isArray(task.refs) ? task.refs : [],
    variants: Array.isArray(task.variants) ? task.variants : [],
    diagnostics: Array.isArray(task.diagnostics) ? task.diagnostics : [],
  }
}
